<section class="section">
  <form id="send-fax-final-step" (ngSubmit)="sendFax()" ngNativeValidate>
    <div *ngIf="notificationsOnly === false">
      <h2 class="section-header">Optional: set filters for easy archiving</h2>
      <div class="send-page__select-field">
        <span>Folder: </span>
        <app-select
          (selectChange)="selectFolder($event)"
          [items]="foldersNames"
          customClass="select_xxl"
          placeholder="Select folder"
        ></app-select>
      </div>
      <br /><br />
      <div class="send-page__txt">
        If needed, you can send a copy of the fax transmission to additional recipients.
      </div>
      <br />
    </div>
    <ul class="section__recipients-list scrollable">
      <li class="send-page__select-and-input" *ngFor="let recipient of additionalRecipients; let i = index">
        <div class="send-page__icon-btn" (click)="removeRecipient(i)">
          <img src="assets/img/icons/delete orange.svg" alt="" />
        </div>
        <app-select
          [items]="contactTypes"
          [activeItem]="recipient.type"
          customClass="select_s"
          (selectChange)="setContactType(recipient, $event)"
        ></app-select>
        <div class="section__input-wrapper">
          <input
            type="text"
            pattern="([A-Za-z0-9._%+-]{3,})+@[A-Za-z0-9.-]+\.[A-Za-z]{1,63}$"
            class="form-input_md recipient-input recipient-input_phone"
            [name]="'recipient-value' + i"
            [(ngModel)]="recipient.value"
            *ngIf="recipient.type === 'Email'; else faxInput"
          />
          <ng-template #faxInput>
            <input
              type="text"
              pattern="(\+?[0-9]{1,2}\s?[\(]*[0-9]{3}[\)]*\s?\d{2,3}[-]*\d{2}[-]*\d{2,40})"
              [name]="'recipient-value' + i"
              [(ngModel)]="recipient.value"
              class="form-input_md recipient-input recipient-input_phone"
            />
          </ng-template>
        </div>
        <div class="section__buttons-wrapper">
          <button type="button" (click)="openRecipientPopup(i)" class="section__button">
            <img src="assets/img/keylock-plus.svg" class="section__img" />
          </button>
          <button (click)="clearContactField(i)" type="button" class="section__button">
            <img src="assets/img/stop.svg" class="section__img" />
          </button>
        </div>
      </li>
    </ul>
  </form>
  <div *ngIf="notificationsOnly === false" class="send-page__actions">
    <button (click)="navigateToPreviousPage()" class="btn_secondary btn_md section__back">
      <img src="assets/img/icons/arrow_back.svg" alt="return back" />
      Edit
    </button>
    <button type="submit" form="send-fax-final-step" class="btn_primary btn_md section__button_next">
      Send
    </button>
  </div>
</section>

<app-select-contact-modal (select)="selectContact($event)"></app-select-contact-modal>
